import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-label" }
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = {
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "card-body pt-0" }
const _hoisted_9 = ["id", "data-id", "checked"]
const _hoisted_10 = { class: "d-flex flex-center flex-wrap" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary custom-slim-btn" }, "Report", -1)
const _hoisted_12 = { class: "d-flex flex-center flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString($setup.breadcrumbs[1][$setup.breadcrumbs[1].length - 1]), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "btn btn-primary custom-slim-btn",
            disabled: !!!$setup.selectedIds?.length,
            "data-bs-toggle": "modal",
            "data-bs-target": "#refund-modal"
          }, " Refund (" + _toDisplayString($setup.selectedIds?.length || 0) + ") ", 9, _hoisted_7)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_Datatable, {
        ref: "tableRef",
        "table-header": $setup.tableHeader,
        "table-data": _ctx.tableData,
        loading: _ctx.loading,
        total: _ctx.total
      }, _createSlots({
        "cell-no": _withCtx(({ index }) => [
          _createTextVNode(_toDisplayString(index + 1 + _ctx.rowsPerPage * (_ctx.currentPage - 1)), 1)
        ]),
        "cell-checkBox": _withCtx(({ row }) => [
          _createElementVNode("input", {
            class: "form-check-input",
            type: "checkbox",
            id: `checkbox${row.id}`,
            "data-id": `${row.id}`,
            checked: !!$setup.selectedIds.includes(row.id),
            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.handleSelected && $setup.handleSelected(...args)))
          }, null, 40, _hoisted_9)
        ]),
        "cell-id": _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(row.id.slice(16).toUpperCase()), 1)
        ]),
        "cell-orderRef": _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(row.payment?.referenceNo || '-'), 1)
        ]),
        "cell-type": _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString($setup.ServicesTypes.find((p) => p.value == row.package?.id)?.name || '-'), 1)
        ]),
        "cell-createdAt": _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString($setup.dateFormat(row.createdAt, 'DD/MM/YYYY')), 1)
        ]),
        "cell-startDate": _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString($setup.dateFormat(row.startDate, 'DD/MM/YYYY')), 1)
        ]),
        "cell-endDate": _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString($setup.dateFormat(row.endDate, 'DD/MM/YYYY')), 1)
        ]),
        "cell-customer": _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(row.customer?.name || '-'), 1)
        ]),
        "cell-amountPrice": _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString($setup.numberFormat(row.amountPrice)), 1)
        ]),
        "cell-details": _withCtx(({ row }) => [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_router_link, {
              to: `/store-report/${row.id}`
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 2
            }, 1032, ["to"])
          ])
        ]),
        "cell-status": _withCtx(({ row }) => [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", {
              class: _normalizeClass(`alert alert-${
                row.status == 'Refunding' ? 'danger' : 'success'
              } custom-slim-btn`),
              role: "alert"
            }, _toDisplayString($setup.mappedStatus[row.status] || 'N/A'), 3)
          ])
        ]),
        _: 2
      }, [
        _renderList($setup.tableHeader.filter(
            (data) =>
              ![
                'checkBox',
                'id',
                'type',
                'createdAt',
                'startDate',
                'endDate',
                'amountPrice',
                'details',
                'status',
                'orderRef',
              ].includes(data.key)
          ), (item, i) => {
          return {
            name: `cell-${item.key}`,
            fn: _withCtx(({ row }) => [
              _createElementVNode("div", null, _toDisplayString(row[`${item.key}`]), 1)
            ])
          }
        })
      ]), 1032, ["table-header", "table-data", "loading", "total"])
    ]),
    _createVNode(_component_ConfirmModal, {
      ref: "modelRef",
      idProps: "refund-modal",
      message: "Are you sure you want to refund this order?"
    }, {
      default: _withCtx(() => [
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.refundOrders && $setup.refundOrders(...args))),
          "data-bs-toggle": "modal",
          "data-bs-target": "#refund-modal",
          type: "button",
          name: "confirm",
          class: "btn btn-primary px-10"
        }, " Refund ")
      ]),
      _: 1
    }, 512)
  ]))
}